import $i18n from '@alife/panda-i18n';

export const DEFAULT_PLACE_HOLDER = $i18n.get({
  id: 'PressEnterToSendCtrlCmdEnterTo',
  dm: '按Enter发送，Ctrl/Cmd+Enter换行',
});
export const TEXT_CONTINUE = $i18n.get({ id: 'Continue', dm: '继续' });
export const UNSUPPORT_MESSAGE_TYPE = $i18n.get({
  id: 'UnrecognizedMessageType',
  dm: '无法识别的消息类型',
});
export const DEFAULT_ERROR = $i18n.get({ id: 'TheServerDeserted', dm: '服务器开小差了' });
